import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    editBureauRequest: ['response'],
    editBureauSuccess: ['loading', 'response'],
    editBureauFailure: ['error'],
})

export const editBureauTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    success: null,
    error: null,
})

/* ------------- Reducers ------------- */

const editBureauRequest = state => state.merge({ success: null })

const editBureauSuccess = (state, { response }) =>
    state.merge({
        success: true,
        error: false,
        response,
    })

const editBureauFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        success: false,
        error: true,
        response,
    })
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.EDIT_BUREAU_REQUEST]: editBureauRequest,
    [Types.EDIT_BUREAU_SUCCESS]: editBureauSuccess,
    [Types.EDIT_BUREAU_FAILURE]: editBureauFailure,
})
